module.exports = __webpack_public_path__ + "static/img/rw.3fba89dc.png";